import { buildPermission } from "common/utils/auth";
import {
  PermissionAction,
  PermissionDomain,
  PermissionResource,
} from "protos/portal/auth";
import { useAuthorizationRequired } from "portal/components/auth/WithAuthorizationRequired";

export const editArchetypesStatement = buildPermission(
  PermissionAction.update,
  PermissionResource.atk_equipment,
  PermissionDomain.all
);

const canSetDangerousParameters = buildPermission(
  PermissionAction.update,
  PermissionResource.atk_equipment,
  PermissionDomain.all
);

/**
 * @returns true if the user can edit equipment archetypes, false otherwise
 */
export const useCanEditArchetypes = (): boolean =>
  useAuthorizationRequired(editArchetypesStatement);

/**
 * some ATK equipment forms expose "dangerous" parameters -- ones which can be
 * easily misconfigured and can cause difficult-to-diagnose issues or damage to
 * the ATK hardware if misconfigured. access to them should be reserved to
 * Carbon engineers.
 * @returns true if the user can set dangerous parameters, false otherwise
 */
export const useCanSetDangerousParameters = (): boolean =>
  useAuthorizationRequired(canSetDangerousParameters);
